import { getUrl } from './links/common';

const routes = {
  url: getUrl,
};
export default routes;
